import styled, { createGlobalStyle } from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
export const GlobalStyle = createGlobalStyle`
  body {
    overflow-x: ${props => props.isBrand ? 'hidden' : ''};
  }`;
export const SliderBase = styled.div`
  margin: 0 auto;
  width: 100%;
  overflow-x: ${props => props.isBrand ? 'hidden' : 'initial'};
  max-width: ${props => props.isBrand ? '100vw' : 'calc(100vw - 32px)'};
  position: relative;
  background: ${props => props.isBrand ? '#222' : 'transparent'};
  padding: ${props => props.isBrand ? '16px 16px 32px 16px' : 'auto'};
  margin: ${props => props.isBrand ? '' : 'auto'};
  box-sizing: border-box;

  &:before {
    display: ${props => props.isBrand ? 'block' : 'none'};
    content: ' ';
    width: 5500px;
    height: 100%;
    position: absolute;
    left: -2000px;
    top: 0;
    right: 0;
  }

  ${breakpoints.md} {
    width: 100%;
    max-width: ${props => props.isBrand ? '100%' : 'calc(100vw - 80px)'};
  }

  ${breakpoints.lg} {
    padding: ${props => props.isBrand ? '16px 40px 32px 40px' : 'auto'};
  }

  .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    user-select: none;
    -webkit-touch-callout: none;
    user-select: none;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;

    ${breakpoints.md} {
      margin: 0;
    }
  }

  .slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    padding: 0;
    margin-right: -8px;

    ${breakpoints.md} {
      margin-right: ${props => props.isBrand ? '-24px' : '-40px'};
    }
  }

  .slick-list:focus {
    outline: none;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .slick-track:before,
  .slick-track:after {
    display: table;
    content: '';
  }

  .slick-track:after {
    clear: both;
  }

  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }

  .slick-slide img {
    display: block;
    object-fit: cover;
    object-position: 50% 50%;
    flex-shrink: 0;
    height: 100%;
    width: 100%;
    background-color: ${({
  theme
}) => theme.tertiary.main};
  }

  .slick-slide > div:first-of-type {
    width: 100%;
    margin-right: 8px;

    ${breakpoints.md} {
      margin-right: ${props => props.isBrand ? '24px' : '40px'};
    }
  }

  .slick-slide.slick-loading img {
    display: none;
  }

  .slick-slide.dragging img {
    pointer-events: none;
  }

  .slick-initialized .slick-slide {
    display: flex;
  }

  .slick-loading .slick-slide {
    visibility: hidden;
  }

  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }

  .slick-arrow.slick-hidden {
    display: none;
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    position: absolute;
    bottom: -25px;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }

  .slick-dots li {
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }

  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }

  .slick-dots li button:before {
    width: 20px;
    height: 20px;
    font-family: 'slick';
    font-size: 6px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;

    content: '•';
    text-align: center;

    opacity: 0.25;
    color: black;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
  }
`;
export const Arrow = styled.button`
  width: 20px;
  height: 40px;
  display: ${props => props.arrows ? 'block' : 'none'};
  background-color: ${({
  theme
}) => theme.primary.main};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  border: 0;
  z-index: 1;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);

  &:hover {
    background: ${({
  theme
}) => theme.primary.light};
  }

  &:focus {
    outline: 2px solid ${({
  theme
}) => theme.base.blue};
    border: 1px solid transparent;
  }

  &:active {
    background: ${({
  theme
}) => theme.primary.dark};
  }

  ${breakpoints.md} {
    width: 40px;
    height: 80px;
  }

  svg {
    fill: ${({
  theme
}) => theme.primary.contrastText};
    margin-left: 0px;
    height: 15px;
    width: 15px;

    ${breakpoints.md} {
      height: 25px;
      width: 25px;
    }

    ${breakpoints.lg} {
      height: 25px;
      width: 25px;
    }
  }
`;
export const PrevArrow = styled(Arrow)`
  left: -16px;

  ${breakpoints.md} {
    left: -20px;
  }

  ${breakpoints.lg} {
    left: ${props => props.isBrand ? '30px' : '-20px'};
  }

  svg {
    transform: rotate(-180deg);
    margin-right: 0;
  }
`;
export const NextArrow = styled(Arrow)`
  right: -16px;

  ${breakpoints.md} {
    right: -20px;
  }

  ${breakpoints.lg} {
    right: ${props => props.isBrand ? '30px' : '-20px'};
  }
`;
export const SliderItemTitle = styled.span`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-shadow: ${({
  theme,
  hasImage
}) => hasImage && `0 2px 4px ${theme.secondary.main}`};
  color: ${({
  theme,
  hasImage
}) => hasImage ? theme.base.white : theme.base.black};
  word-break: break-word;
  margin: 16px 0;
  position: absolute;
  z-index: 1;
  display: inline-block;
  max-width: calc(100% - 40px);
  max-height: 70%;
  left: 20px;
  bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${breakpoints.md} {
    max-width: calc(100% - 40px);
    left: 20px;
    font-size: 24px;
    line-height: 2rem;
  }

  ${breakpoints.lg} {
    line-height: 40px;
    bottom: 24px;
  }

  &:after {
    content: '';
    height: 0;
    transform: scaleX(0);
    border-bottom: 4px solid ${({
  theme
}) => theme.primary.main};
    transition: all 0.2s ease-in-out;
    transform-origin: left center;
    display: block;
  }
`;
export const SliderItem = styled.div`
  height: 172px;
  position: relative;
  width: 100%;

  ${breakpoints.md} {
    height: 480px;
    margin: 0 0 0 0;
  }

  ${breakpoints.lg} {
    height: 520px;
  }

  &:after {
    content: '';
    display: block;
    height: 80px;
    width: 100%;
    max-width: 100%;
    position: absolute;
    bottom: 0;
    background: ${({
  hasImage
}) => hasImage && 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7))'};

    ${breakpoints.md} {
      height: 170px;
      margin: 0;
    }
  }

  &:hover {
    ${SliderItemTitle}:after {
      content: '';
      margin: 4px 0;
      transform: scaleX(1);
      transform-origin: left center;
      transition: all 0.2s ease-in-out;
    }
  }
`;
export const SliderItemVideo = styled.div`
  margin: 8px;
  position: relative;

  ${breakpoints.md} {
    margin: 0;
  }

  ${breakpoints.lg} {
    margin: 0 8px 0 13px;
  }

  /* cardWrapper */
  a > div:first-of-type {
    display: block;
  }

  /* cardImageContainer */
  a > div:first-of-type > div:first-of-type {
    display: block;
    width: 100%;
    height: 120px;

    ${breakpoints.md} {
      height: initial;
    }

    ${breakpoints.lg} {
      height: initial;
    }
  }

  /* cardIconBox */
  a > div:first-of-type > div:nth-child(2) {
    right: 0;
    left: initial;
  }

  /* cardBody */
  a > div:first-of-type > div:nth-child(3) {
    display: block;
  }
`;
export const SliderItemBody = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: content-box;
`;
export const SliderItemLabel = styled.span`
  font-size: 13px;
  color: ${({
  theme,
  hasImage
}) => hasImage ? theme.base.white : theme.primary.main};
  word-break: break-word;
  position: absolute;
  z-index: 1;
  display: inline-block;
  max-width: calc(100% - 20px);
  left: 20px;
  bottom: 16px;

  ${breakpoints.md} {
    left: 20px;
  }
`;